import { useEffect, useRef } from 'react';

import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { registerSuperPropertiesStore } from '@jane/bloom/services/tracking/mixpanel';
import { trackStoreSet } from '@jane/bloom/services/tracking/track';

export const useTrackInitialStorePin = () => {
  const { featureFlags, pinnedStore, stores, wasStoreInitiallyResolved } =
    useRootLoaderData();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!wasStoreInitiallyResolved || hasTracked.current) return;

    const store = stores.find((s) => s.id === pinnedStore.id);
    if (!store) return;

    hasTracked.current = true;
    registerSuperPropertiesStore({
      storeCity: store.city,
      storeId: store.id,
      storeName: store.name,
      storeState: store.state,
    });
    trackStoreSet(undefined, featureFlags);
  }, [featureFlags, pinnedStore, stores, wasStoreInitiallyResolved]);
};
